import React from "react";
import { cdrAPI, productosAPI, reservasAPI, toolsAPI } from "./funcionesAPI.js";
import { toast } from "react-toastify";
import {
  SET_PROVINCIAS_PARA_HOTELES,
  SET_SEGURO_CANCELACION,
} from "../context/constantes.js";
import estrella from "../imagenes/paquetes/ribbon/star.svg";
import get from "./get.js";

const meses = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const isLogged = () => {
  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");

  if (token && user) return true;
  return false;
};

function manejadorDeRespuesta(props, respuesta) {
  let rto = true;
  if (!respuesta) {
    toast.error(
      "Ha ocurrido un error, por favor comuniquese con nuestros operadores " +
        respuesta,
      {
        position: toast.POSITION.BOTTOM_CENTER,
      },
    );
    rto = false;
  } else if (respuesta.estado === "error") {
    switch (respuesta.codigo) {
      case 999:
        toast.info("Ha expirado la sesión", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        sessionStorage.clear();
        props.history.push("/");
        rto = false;
        break;
      case 998:
        toast.error("Debe completar todos los datos del formulario", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        rto = false;
        break;
      default:
        toast.error(respuesta.mensaje, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        //alert(respuesta.mensaje);
        rto = false;
        break;
    }
  }

  return rto;
}

function stockEnDemanda(accion, props) {
  const token = sessionStorage.getItem("token");
  const charter = JSON.parse(sessionStorage.getItem("charter"));
  const pasajerosAdultos = JSON.parse(
    sessionStorage.getItem("pasajerosAdultos"),
  );
  const pasajerosMenores = JSON.parse(
    sessionStorage.getItem("pasajerosMenores"),
  );

  //BORRAR STOCK EN DEMANDA
  if (charter && token && pasajerosAdultos && pasajerosMenores) {
    let data = JSON.stringify({
      peticion: "stockDemanda",
      accion: accion,
      token: token,
      idCharter: charter.idCharter,
      pasajeros: pasajerosAdultos.length + pasajerosMenores.length,
    });
    reservasAPI(data).then((resultado) => {
      /*
      if (!resultado) {
        console.log("Error en el servidor");
      } else if (resultado === false) {
        alert("Lamentablemente No disponemos de lugares Para esa fecha");
        this.props.history.push("/");
        return;
      }
      */
      if (!resultado) {
        console.log("Error en el servidor");
        alert(
          "La sesión de reserva ha finalizado. Deberá volver a comenzar el proceso de compra. Recuerde que tiene 8 minutos.",
        );
        if (accion !== 9) {
          props && props.history && props.history.push("/");
        }

        return;
      } else if (typeof resultado === "string") {
        console.log("Error en el servidor");
        return;
      }
    });
  }
}

const getTarifaBase = (charter) => {
  return (
    charter.tarifa.tarifa -
    charter.tarifa.tarifa * (charter.promoValijaYa / 100)
  );
};

const calcularImpuestosPais = (
  idProducto,
  charter,
  pasajerosPagantes,
  origen,
  tipoCliente,
  tarifa,
  setter,
  props,
) => {
  const data = JSON.stringify({
    peticion: "traerImpuestoPAISNuevo",
    idProducto,
    tarifa,
    pasajerosPagantes,
    origen,
    fechaSalida: charter.fechaSalida,
    tipoCliente,
  });
  productosAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta(props, respuesta)) {
      setter(respuesta.data);
    }
  });
};

const traerModalidadTarjeta = (setModalidad) => {
  const data = JSON.stringify({
    accion: "traerModalidadTarjeta",
  });

  toolsAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta({}, respuesta)) {
      setModalidad(respuesta.data);
    }
  });
};

const traerReservasPorUsuario = (props, token, setCantidadReservas) => {
  if (token) {
    const data = JSON.stringify({
      peticion: "traerCantidadReservasPorCliente",
      token: token,
    });

    reservasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setCantidadReservas(Number(respuesta.data));
        // _this.setState({cantidadReservas: Number(respuesta.data)});
      }
    });
  }
};

export const seleccionarHabitacionPorDefault = (
  habitaciones = [],
  cantidadPasajeros = 2,
) => {
  debugger;
  const habEncontradas = habitaciones.filter(
    (hab) => Number(hab.capacidadTipo) === cantidadPasajeros,
  );
  return habEncontradas.length > 0 ? habEncontradas : [habitaciones[0]];
};

export const calcularTotalCapacidad = (habit) => {
  let totalCapacidad = 0;
  habit.forEach((hab) => (totalCapacidad += Number(hab.capacidadTipo)));
  return totalCapacidad;
};
//no la uso mas
export const calcularTotalesHabitacionPorDefault = (
  charter,
  habitaciones = [],
) => {
  if (habitaciones.length === 0) {
    return {
      total: 0,
      totalPorPersona: 0,
      totalPorPersonaNeto: 0,
      totalPorPersonaConValijaYa: 0,
      totalTasasEimpuestos: 0,
    };
  }

  let total = 0;
  let totalTasasEimpuestos = 0;
  let totalCapacidad = 0;
  let totalNeto = 0;

  habitaciones.forEach((habitacion) => {
    total =
      total + habitacion.tarifaPorPersona * Number(habitacion.capacidadTipo);
    totalCapacidad = totalCapacidad + Number(habitacion.capacidadTipo);
    totalNeto =
      totalNeto +
      (habitacion.tarifaPorPersona - habitacion.tasasEimpuestos) *
        habitacion.capacidadTipo;
    totalTasasEimpuestos = totalTasasEimpuestos + habitacion.tasasEimpuestos;
  });

  const totalPorPersona = Math.round(total / totalCapacidad, 2);
  const totalPorPersonaNeto = Math.round(totalNeto / totalCapacidad, 2);
  const totalPorPersonaConValijaYa =
    totalPorPersona -
    totalPorPersona * (charter.promoValijaYa / 100) +
    charter.tarifa.adicionalPorDia;

  return {
    total: Math.round(total, 2),
    totalPorPersona,
    totalPorPersonaNeto,
    totalPorPersonaConValijaYa,
    totalTasasEimpuestos: Math.round(totalTasasEimpuestos, 2),
    totalCapacidad: totalCapacidad,
  };
};

export const calcularTotalesHabitaciones = (
  idCharter,
  habitaciones,
  origen,
  setter,
) => {
  const data = JSON.stringify({
    accion: "calcularTotalesDeHabitaciones",
    idCharter,
    habitaciones,
    origen,
  });
  toolsAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta({}, respuesta)) setter(respuesta.data);
  });
};

export const getLocalidadesPorPartido = (codigoPartido, setter) => {
  const data = JSON.stringify({
    accion: "localidadesPorPartido",
    codigoPartido,
  });
  toolsAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta({}, respuesta)) setter(respuesta.data);
  });
};

export const getPartidosPorProvincia = (codigoProvincia, setter) => {
  const data = JSON.stringify({ accion: "partidos", codigoProvincia });
  toolsAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta({}, respuesta)) setter(respuesta.data);
  });
};

export const traerDestinosParaCDR = (dispatch) => {
  const data = JSON.stringify({
    peticion: "traerDestinosParaCDR",
  });

  cdrAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta({}, respuesta)) {
      dispatch({
        type: SET_PROVINCIAS_PARA_HOTELES,
        payload: { destinos: respuesta.data },
      });
      /*
      setState((state) => ({
        ...state,
        provinciasParaHoteles: respuesta.data,
      }));
      */
      // setState(respuesta.data);
    }
  });
};

export const calcularSeguroDeCancelacion = (tarifaBase, dispatch, interes) => {
  const data = JSON.stringify({
    accion: "calcularSeguroDeCancelacion",
    totalPaquete: tarifaBase,
  });
  toolsAPI(data).then((respuesta) => {
    if (manejadorDeRespuesta({}, respuesta)) {
      dispatch({
        type: SET_SEGURO_CANCELACION,
        payload: { totalSeguro: respuesta.data, interes },
      });
    }
  });
};

export const convertirParamAHabitaciones = (pasajeros) => {
  if (!pasajeros) return [{ adultos: 2, menores: [] }];
  const cantidadHabitaciones = pasajeros.split(",");
  return cantidadHabitaciones.map((hab) => {
    const personasPorHabitacion = hab.split("-");
    const adultos =
      personasPorHabitacion &&
      personasPorHabitacion.length > 0 &&
      personasPorHabitacion.shift();
    const menores =
      (personasPorHabitacion &&
        personasPorHabitacion.length > 0 &&
        personasPorHabitacion.map((menor) => menor)) ||
      [];
    return { adultos, menores };
  });
};

export const convertirHabitacionesAParam = (habitaciones = []) => {
  if (habitaciones.length === 0) return "2";
  let param = "";
  habitaciones.forEach((hab) => {
    param += `${hab.adultos}${hab.menores.length > 0 ? "-" + hab.menores.join("-") : ""},`;
  });
  return param[param.length - 1] === ","
    ? param.substring(0, param.length - 1)
    : param;
};

export const crearPasajerosDefault = (cantidad, tipo) => {
  const pasajeros = new Array(Number(cantidad));
  pasajeros.fill({
    tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
    nacionalidad: { id: 1, denominacion: "Argentina" },
    sexo: "M",
    tipoPasajero: tipo,
  });
  return pasajeros;
};

export const totalPasajeros = (habitaciones) => {
  let totalAdultos, totalMenores;
  totalAdultos = totalMenores = 0;
  habitaciones.forEach((hab) => {
    totalAdultos += Number(hab.adultos);
    totalMenores += hab.menores.length;
  });

  return { totalAdultos, totalMenores };
};

/*function calcularFamilyPlanNeto(producto, charter, adultos, menores) {
    let totalTarifaFamilyPlan = 0;
    let tarifaNetaPorPersona = Math.round((((charter.tarifa.tarifaNeta - (charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)))) + charter.tarifa.adicionalPorDia) * producto.moneda.cotizacion);
    let totalTarifaNetaAdultos = tarifaNetaPorPersona * adultos.length;

    producto.planesFamily.forEach(plan => {
          if (plan.cantidadPasajerosTotal === (adultos.length + menores.length) && plan.cantidadAdultos === adultos.length && plan.cantidadMenores === menores.length) {
            totalTarifaFamilyPlan += totalTarifaNetaAdultos; //Math.round((((charter.tarifa.tarifaNeta - (charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)))) + charter.tarifa.adicionalPorDia) * producto.moneda.cotizacion).toLocaleString();
            menores.forEach(menor => {//fc: hacer find de detalle
              for (let i = 0; i < plan.detalles.length; i++)  {//plan.detalles.forEach(det => {
                if (Number(menor.edad) >= plan.detalles[i].edadDesde && Number(menor.edad) <= plan.detalles[i].edadHasta) {
                  totalTarifaFamilyPlan += tarifaNetaPorPersona * (plan.detalles[i].porcentaje / 100);
                  break;
                } else {
                    if (Number(menor.edad) >= 2) {
                      totalTarifaFamilyPlan += tarifaNetaPorPersona;
                    }
                }
              }
            })

          }
        })

    return totalTarifaFamilyPlan;
  }*/

function calcularFamilyPlan(producto, charter, adultos, menores) {
  let totalTarifaFamilyPlan = 0;
  let tarifaPorPersona = Math.round(
    (charter.tarifa.tarifa -
      charter.tarifa.tarifa * (charter.promoValijaYa / 100) +
      charter.tarifa.adicionalPorDia) *
      producto.moneda.cotizacion,
  );
  let totalTarifaNetaAdultos = tarifaPorPersona * adultos.length;

  producto.planesFamily.forEach((plan) => {
    if (
      plan.cantidadPasajerosTotal === adultos.length + menores.length &&
      plan.cantidadAdultos === adultos.length &&
      plan.cantidadMenores === menores.length &&
      despejarInfoas(menores) === 0
    ) {
      totalTarifaFamilyPlan += totalTarifaNetaAdultos; //Math.round((((charter.tarifa.tarifaNeta - (charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)))) + charter.tarifa.adicionalPorDia) * producto.moneda.cotizacion).toLocaleString();
      menores.forEach((menor) => {
        //fc: hacer find de detalle
        for (let i = 0; i < plan.detalles.length; i++) {
          //plan.detalles.forEach(det => {
          if (
            Number(menor.edad) >= plan.detalles[i].edadDesde &&
            Number(menor.edad) <= plan.detalles[i].edadHasta
          ) {
            //if(plan.detalles[i].porcentaje === 100)
            //plan.detalles[i].porcentaje = 0;
            totalTarifaFamilyPlan +=
              tarifaPorPersona * (plan.detalles[i].porcentaje / 100);
            break;
          } else {
            //if (Number(menor.edad) >= 2) {
            totalTarifaFamilyPlan += tarifaPorPersona;
            //}
          }
        }
      });
    }
  });

  return totalTarifaFamilyPlan;
}

function calcularEdad(fecha) {
  var timeDiff = Math.abs(Date.now() - new Date(fecha));
  var edad = Math.ceil(timeDiff / (1000 * 3600 * 24) / 365) - 1;
  return edad;
}

function despejarInfoas(menores) {
  let menoresInfoas = 0;
  for (var i = 0; i < menores.length; i++) {
    if (menores[i].edad < 2) menoresInfoas++;
  }

  return menoresInfoas;
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function convertirFecha(fecha) {
  //Formato: Lunes 18 de Marzo de 2018
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  let fechaEnJS = new Date(fecha);
  fechaEnJS.setDate(fechaEnJS.getDate() + 1);
  return fechaEnJS.toLocaleDateString("es-ES", options);
}

function mostrarMes(fecha) {
  //Formato: 2018-01-01
  let mes = Number(fecha.split("-")[1]) - 1;
  return meses[mes];
}

function mostrarNombreMes(fecha) {
  //Formato: 022018
  const mes = Number(fecha.substring(0, 2)) - 1;
  return meses[mes];
}

function formatearFecha(fecha) {
  //fecha= '2018-05-01'
  let arrayDeLaFecha = fecha.split("-");
  let fechaFormateada = arrayDeLaFecha[1] + arrayDeLaFecha[0].substring(0, 4);
  return fechaFormateada; //'052018'
}

function mostrarNombreOrigen(codigo) {
  const origenes = { CENT: "Buenos Aires", ROSC: "Rosario", CBA1: "Cordoba" };
  return origenes[codigo];
}

function convertirPeriodoEnBuscador(fecha) {
  const mes = mostrarMes(fecha);
  const anio = fecha.substring(0, 4);
  return mes + " " + anio;
}

function convertirPeriodoEnValue(fecha) {
  const mes = fecha.substring(5, 7);
  const anio = fecha.substring(0, 4);
  return mes + anio;
}

function sumarFecha(fechaDesde, cantidadDias) {
  let milisegundos = Number(35 * 24 * 60 * 60 * 1000);

  let fecha = new Date();
  let fechaEnJS = new Date(fechaDesde);
  fechaEnJS.setDate(fechaEnJS.getDate() + 1);

  //const day = fechaEnJS.getDate();
  // el mes es devuelto entre 0 y 11
  //const month = fechaEnJS.getMonth() + 1;
  //const year = fechaEnJS.getFullYear();

  //Obtenemos los milisegundos desde media noche del 1/1/1970
  const tiempo = fechaEnJS.getTime();
  //Calculamos los milisegundos sobre la fecha que hay que sumar o restar...
  milisegundos = Number(cantidadDias * 24 * 60 * 60 * 1000);
  //Modificamos la fecha actual
  fecha.setTime(tiempo + milisegundos);

  return deBaseAFechaLocal(deJSAFechaAmericana(fecha));
}

export const sumarFechaEnJSYDevolverBase = (fechaEnJS, cantidadDias) => {
  let milisegundos = Number(35 * 24 * 60 * 60 * 1000);
  let fecha = new Date();

  const tiempo = fechaEnJS.getTime();

  milisegundos = Number(cantidadDias * 24 * 60 * 60 * 1000);
  //Modificamos la fecha actual
  fecha.setTime(tiempo + milisegundos);

  return deJSAFechaAmericana(fecha);
};

function deBaseAFechaLocal(fecha_en_iso) {
  if (fecha_en_iso === "0001-01-01T00:00:00" || !fecha_en_iso) return "";

  var regexp_fecha_iso = /(\d{1,4}-\d{1,2}-\d{1,2})T(\d{1,2}:\d{1,2}:\d{1,2})/;
  if (regexp_fecha_iso.test(fecha_en_iso)) {
    fecha_en_iso = regexp_fecha_iso.exec(fecha_en_iso)[1].replace(/-/g, "/");
  }

  var fecha = new Date(fecha_en_iso);
  if (fecha.getUTCDate().toString() === "NaN") return "";

  
  var partes = fecha_en_iso.split(/[T\s]/)[0].split("-");
  
  if (partes.length !== 3) return "";

  var anio = partes[0];
  var mes  = parseInt(partes[1], 10); // Base 10 para evitar líos con el "08" en JS viejo
  var dia  = parseInt(partes[2], 10);


  return dia + "/" + mes + "/" + anio;
/*
  return (
    fecha.getUTCDate().toString() +
    "/" +
    (fecha.getUTCMonth() + 1).toString() +
    "/" +
    fecha.getUTCFullYear()
  );
  */
}

function deJSAFechaAmericana(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
}

export const calcularDiasEntreFechas = (fechaInicio, fechaFin) => {
  const fechaInicioEnMs = fechaInicio.getTime();
  const fechaFinEnMs = fechaFin.getTime();
  const diff = fechaFinEnMs - fechaInicioEnMs;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const calcularPrecioCharter = (charter = {}) => {
  const tarifaNeta = get(charter, "tarifa.tarifaNeta", 0);
  const adicionalPorDia = get(charter, "tarifa.adicionalPorDia", 0);
  if (tarifaNeta === 0) return undefined;
  return Math.round(
    tarifaNeta - tarifaNeta * (charter.promoValijaYa / 100) + adicionalPorDia,
  ).toLocaleString();
};

function validateEmail(email) {
  var re =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return re.test(String(email).toLowerCase());
}

function checkCookie() {
  var mostrarAviso = getCookie("mostrarAviso");
  if (mostrarAviso !== "") {
    return true;
  }
  return false;
}

function setCookie(nombre, valor, diasAExpirar) {
  var d = new Date();
  d.setTime(d.getTime() + diasAExpirar * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = nombre + "=" + valor + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const validarDatosPasajeros = (pasajeros) => {
  //const {pasajerosAdultos, pasajerosMenores} = this.props;
  let rto = true;
  pasajeros.forEach(function (unPasajero) {
    for (var key in unPasajero) {
      if (
        !unPasajero.hasOwnProperty("nombre") ||
        !unPasajero.hasOwnProperty("apellido") ||
        !unPasajero.hasOwnProperty("telefono") ||
        !unPasajero.hasOwnProperty("fechaNacimiento") ||
        !unPasajero.hasOwnProperty("documento")
      ) {
        rto = false;
      }

      if (
        (key === "nombre" && unPasajero[key] === "") ||
        (key === "apellido" && unPasajero[key] === "") ||
        (key === "telefono" && unPasajero[key] === "") ||
        (key === "fechaNacimiento" && unPasajero[key] === "") ||
        (key === "documento" && unPasajero[key] === "")
      ) {
        rto = false;
      }
    }
  });
  return rto;
};

export const validarEdadMenores = (pasajeros) => {
  let rto = true;
  pasajeros.forEach(function (unPasajero) {
    let edad = calcularEdad(unPasajero.fechaNacimiento);
    if (Number(unPasajero.edad) !== edad) {
      rto = false;
    }
  });
  return rto;
};

export const validarEdadAdultos = (pasajeros) => {
  let rto = true;
  pasajeros.forEach(function (unPasajero) {
    let edad = calcularEdad(unPasajero.fechaNacimiento);
    if (edad < 2) {
      rto = false;
    }
  });
  return rto;
};

export const validarDatosDeFacturacion = (formFacturacion) => {
  if (
    formFacturacion.razonSocial === "" ||
    !formFacturacion.razonSocial ||
    formFacturacion.mail === "" ||
    formFacturacion.calle === "" ||
    formFacturacion.altura === "" ||
    formFacturacion.codigoPostal === "" ||
    formFacturacion.provincia.id === 0 ||
    formFacturacion.localidad.id === 0 ||
    formFacturacion.numeroDocumento === "" ||
    formFacturacion.factura === "" ||
    formFacturacion.tipoDocumento.sigla === "" ||
    formFacturacion.responsabilidad === "" ||
    formFacturacion.responsabilidad === "0"
  ) {
    return {
      estado: false,
      mensaje: "Debe completar todos los campos de facturacion",
    };
  }
  if (formFacturacion.calle.length < 1) {
    return {
      estado: false,
      mensaje: "La calle debe tener al menos 1 caracter",
    };
  }
  if (formFacturacion.razonSocial.trim().length < 2) {
    return {
      estado: false,
      mensaje: "Debe escribir al menos 2 caracteres para la Razon Social",
    };
  }
  if (
    formFacturacion.tipoDocumento.sigla === "CUIT" ||
    formFacturacion.tipoDocumento.sigla === "CUIL"
  ) {
    if (!validateCUITorCUIL(formFacturacion.numeroDocumento)) {
      return {
        estado: false,
        mensaje: "El numero de CUIT/CUIL no es correcto",
      };
    }
  }
  return { estado: true, mensaje: "" };
};

export const calcularTotalRegimen = (producto, pasajerosPagantes) => {
  const { habitaciones, cantidadNoches } = producto || {};
  return habitaciones.reduce((accumulator, current) => {
    return (
      accumulator +
      parseFloat(get(current, "regimenSeleccionado.precio", 0)) *
        cantidadNoches *
        current.tipoDeHabitacion.capacidadTipo
    );
  }, 0);
};

export const calcularInfoas = (pasajerosMenores = []) => {
  return pasajerosMenores.reduce((accumulator, current) => {
    const value = Number(current) <= 2 ? 1 : 0;
    return accumulator + value;
  }, 0);
};

export const dibujarEstrellas = (cantidad) => {
  return Array.from(Array(cantidad)).map((es, i) => (
    <span key={i}>
      <img alt="estrella" width="20" src={estrella} />
    </span>
  ));
};

export const ICONOS_CDR = {
  Piscina: "pool",
  WIFI: "wifi",
  Bar: "wine_bar",
  Comedor: "restaurant",
  Solarium: "light_mode",
  Parking: "directions_car",
  "A.C.": "air",
  DESAYUNO: "free_breakfast",
};

export const armarFilasDelSlider = (productos = []) => {
  const productos1raFila = productos.filter(p => p.cabecera === "CENT");
  const productos2daFila = productos.filter(p => p.cabecera === "ROSC");
  const productos3raFila = productos.filter(p => p.cabecera === "LAPL");
  /*FC: vieja implementacion
  let productos1raFila = productos;
  let productos2daFila = [];
  let productos3raFila = [];
  let filasDeSlider = 2;
  //if (productos.length < 8) {
  if (productos.length < 8) {
    filasDeSlider = 1;
  } else if (productos.length >= 12) {
    filasDeSlider = 3;
  }

  let mitad = productos.length / 2;
  let enteroSuperior = Math.ceil(mitad);
  if (filasDeSlider === 2) {
    productos1raFila = productos.slice(0, enteroSuperior);
    productos2daFila = productos.slice(enteroSuperior, productos.length);
  } else if (filasDeSlider === 3) {
    let tercio = productos.length / 3;
    enteroSuperior = Math.ceil(tercio);
    let enteroInferior = Math.floor(tercio);
    productos1raFila = productos.slice(0, enteroSuperior);
    productos2daFila = productos.slice(
      enteroSuperior,
      enteroSuperior + enteroInferior,
    );
    productos3raFila = productos.slice(
      enteroSuperior + enteroInferior,
      productos.length,
    );
  }
  */

  return { productos1raFila, productos2daFila, productos3raFila };
};

const tiposDeEventos = {
  CONTACTO: "AW-783256938/NYraCJDitv8CEOqavvUC",
  SUSCRIPCION: "AW-783256938/YdbbCKrJtv8CEOqavvUC",
  WHATSAPP: "AW-783256938/YdbbCKrJtv8CEOqavvUC",
};

export const gtag_report_conversion = (url, typeOfEvent) => {
  var callback = () => {
    if (typeof url != "undefined") {
      // window.location = url;
    }
  };

  window.gtag("event", "conversion", {
    send_to: tiposDeEventos[typeOfEvent],
    event_callback: callback,
  });
  return false;
};

export const transformText = (string = "") => {
  return capitalizeFirstLetter(string.toLowerCase());
};

export const traerTarjetasDisponibles = () => {
  //FC: como se fue MP, pusimos las nuestras
  //{id: 6, legals: '', issuer: {id: '10442222', name: 'Banco Provincia'}, max_installments: 'Hasta 9 cuotas'},
  /*
{
      id: 4,
      legals: "",
      issuer: { id: "nuevo_ahora18", name: "Ahora 18" },
      max_installments: "",
    },
  */
  const tarjetas = [
    /*{
      id: 1,
      legals: "",
      issuer: { id: "ahora3_white", name: "Ahora 3" },
      max_installments: "",
      width: '40'
    },
    {
      id: 2,
      legals: "",
      issuer: { id: "ahora6_white", name: "Ahora 6" },
      max_installments: "",
      width: '40'
    },
    {
      id: 3,
      legals: "",
      issuer: { id: "ahora12_white", name: "Ahora 12" },
      max_installments: "",
      width: '40'
    }, 
    
    {
      id: 1,
      legals: "",
      issuer: { id: "cuota_simple2", name: "Cuota Simple" },
      max_installments: "",
      width: '80'
    }, 
    */
    {
      id: 5,
      legals: "",
      issuer: { id: "cabal_white", name: "Cabal" },
      max_installments: "",
      width: "50",
    },
    {
      id: 6,
      legals: "",
      issuer: { id: "naranja_white", name: "Naranja" },
      max_installments: "",
      width: "110",
    },
    {
      id: 7,
      legals: "",
      issuer: { id: "american_white", name: "Amerecina" },
      max_installments: "",
      width: "110",
    },
    {
      id: 8,
      legals: "",
      issuer: { id: "master_white", name: "Mastercard" },
      max_installments: "",
      width: "80",
    },
    {
      id: 9,
      legals: "",
      issuer: { id: "visa_white", name: "Visa" },
      max_installments: "",
      width: "80",
    },
  ];

  return tarjetas;
};

//valida cuit/cuil 11 caracteres sin guion
export const validateCUITorCUIL = (cuil) => {
  if (cuil.length !== 11) {
    return false;
  }

  const [checkDigit, ...rest] = cuil.split("").map(Number).reverse();

  const total = rest.reduce(
    (acc, cur, index) => acc + cur * (2 + (index % 6)),
    0,
  );

  const mod11 = 11 - (total % 11);

  if (mod11 === 11) {
    return checkDigit === 0;
  }

  if (mod11 === 10) {
    return false;
  }

  return checkDigit === mod11;
};

export const fechaEnRango = (fecha, cantDias) => {
  //formato fecha aaaa-mm-dd
  // Obtener la fecha actual
  var hoy = new Date();

  // Convertir la fecha proporcionada a un objeto Date
  var fechaProporcionada = new Date(fecha);

  // Calcular la diferencia en milisegundos entre las fechas
  var diferenciaMilisegundos = hoy - fechaProporcionada;

  // Convertir la diferencia de milisegundos a días
  var diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);

  // Verificar si la diferencia está dentro del rango de -3 a 0 días
  return diferenciaDias >= cantDias && Math.trunc(diferenciaDias) <= 0;
};

export {
  calcularEdad,
  despejarInfoas,
  convertirFecha,
  capitalizeFirstLetter,
  sumarFecha,
  deBaseAFechaLocal,
  deJSAFechaAmericana,
  stockEnDemanda,
  manejadorDeRespuesta,
  mostrarMes,
  mostrarNombreMes,
  mostrarNombreOrigen,
  convertirPeriodoEnBuscador,
  convertirPeriodoEnValue,
  validateEmail,
  formatearFecha,
  calcularFamilyPlan,
  checkCookie,
  setCookie,
  traerReservasPorUsuario,
  getTarifaBase,
  calcularImpuestosPais,
  traerModalidadTarjeta,
};



// WEBPACK FOOTER //
// ./src/utils/Tools.js